<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCartStore } from '../stores/cart';
import xmarkIcon from '@fortawesome/fontawesome-pro/svgs/solid/xmark.svg?raw';
import arrowRightIcon from '@fortawesome/fontawesome-pro/svgs/regular/arrow-right.svg?raw';
import circleCheckIcon from '@fortawesome/fontawesome-pro/svgs/solid/circle-check.svg?raw';

const { t } = useI18n({ useScope: 'global' });
const cart = useCartStore();
const couponInput = ref('');

async function applyCoupon(): Promise<void> {
    if (!couponInput.value.trim()) return;
    await cart.setCouponCode(couponInput.value);
    couponInput.value = '';
}

async function removeCoupon(): Promise<void> {
    await cart.setCouponCode('');
}
</script>

<template>
    <div class="cart-coupon">
        <template v-if="cart.cart?.couponCode">
            <span class="form-label cart-coupon__label">{{ t('cart.couponCode') }}</span>

            <div class="cart-coupon__applied">
                <div class="cart-coupon__success">
                    <span class="cart-coupon__active-code">{{ cart.cart.couponCode }}</span>
                    <span class="cart-coupon__check" aria-hidden="true" v-html="circleCheckIcon" />
                </div>

                <button type="button" class="cart-coupon__remove" @click="removeCoupon">
                    <span>{{ t('cart.removeCoupon') }}</span>
                </button>
            </div>
        </template>

        <form v-else class="cart-coupon__form" @submit.prevent="applyCoupon">
            <label class="form-label cart-coupon__label" for="cart-coupon-input">
                {{ t('cart.couponCode') }}
            </label>

            <div class="cart-coupon__field">
                <input
                    id="cart-coupon-input"
                    type="text"
                    class="form-control cart-coupon__input"
                    v-model="couponInput"
                />
                <button type="submit" class="cart-coupon__submit">
                    <span class="visually-hidden">{{ t('cart.applyCoupon') }}</span>
                    <span aria-hidden="true" v-html="arrowRightIcon" />
                </button>
            </div>
        </form>
    </div>
</template>
